import $ from 'jquery'
import formatMessage from 'format-message'
import formatMessageGenerateId from 'format-message-generate-id/underscored_crc32'
import env from '@polleverywhere/core/lib/env'

const translationCache = new Map()

async function getNamespace (locale = '', cdnUrl) {
  if (translationCache.has(locale)) {
    return translationCache.get(locale)
  }

  const fileUrl = cdnUrl
    ? `${cdnUrl}/locales/${locale}.json`
    : `/locales/${locale}/messages.json`

  const translations = await $.getJSON(fileUrl)
  const namespace = formatMessage.namespace()

  namespace.setup({
    generateId: formatMessageGenerateId,
    translations,
    locale
  })

  translationCache.set(locale, namespace)

  return namespace
}

export function defaultLocale () {
  return formatMessage
}

export async function loadLocale (locale = 'en', cdnUrl = env.get('cdn_url'), options = {}) {
  if (locale === 'en') {
    return defaultLocale()
  }

  try {
    return await getNamespace(locale, cdnUrl)
  } catch (error) {
    console.log(`Locale "${locale}" cannot be loaded.`, error)
    return formatMessage
  }
}
